import React from "react";
import "./NowPlaying.css";

function NowPlaying() {
  return (
    <div className="nowplaying">
      <div className="signup--div">Sign up free</div>
      <div className="nowplaying--title">PREVIEW OF PLAYIFY</div>
      <div className="nowplaying--details">
        Playify is coming soon, you can't play or listen to any songs yet! In
        the meantime, you can explore latest and trending songs, and search for
        songs.
      </div>
    </div>
  );
}

export default NowPlaying;
